import React, { useState } from "react";
import { Skeleton } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Radio } from "antd";
import { useEffect } from "react";
import { FETCH_DASHBOARD_MORE } from "../../actions/InterbranchAdminActions";
function MisReportModalContent() {
  const dispatch = useDispatch();
  let [loader, setloader] = useState(true);
  let appointmentDetails = useSelector(
    (state) => state.interbranchAdmin.detaiedSelected
  );
  let [appointmentDetailsV2, setAppointmentDetailsV2] = useState({});

  let openFile = () => {
    window.open(appointmentDetails?.Invoice_File_Link, "_blank");
  };

  useEffect(() => {
    dispatch(FETCH_DASHBOARD_MORE(appointmentDetails?.appointmentid)).then(
      (res) => {
        console.log("res", res);
        setAppointmentDetailsV2(res);
        //loaddoctors();
        setloader(false);
      }
    );
  }, [appointmentDetails]);

  console.log(appointmentDetails);

  return (
    <div className="today-report-modal-content">
      {!loader ? (
        <>
          <div className="header">
            Appointment ID - {appointmentDetails?.appointmentid}
          </div>

          <div className="todays-report-timeline">
            <table className="todays_report_table">
              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Appointment Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Appointment ID</td>

                  <td className="cell3 odd">
                    {appointmentDetails?.appointmentid}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">
                    Appointment Requested Date & Time
                  </td>

                  <td className="cell3 even">
                    {appointmentDetailsV2?.requestedDatetime || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Appointment Date</td>

                  <td className="cell3 even">
                    {appointmentDetails?.appointmentdate}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Appointment Time</td>

                  <td className="cell3 odd">
                    {appointmentDetails?.appointmenttime}
                  </td>
                </tr>

                {appointmentDetails?.consultationstatus != "Upcoming" && 
                  <tr>
                        <td className="cell1 even">Rating</td>
                        <td className="cell3 even">
                          {appointmentDetails?.rating!=undefined && appointmentDetails?.rating!="NA" ?appointmentDetails?.rating+" Stars" : "NA"}
                        </td>
                      </tr> 
                  }
                 {appointmentDetails?.consultationstatus != "Upcoming" && 
                  <tr>
                        <td className="cell1 even">Feedback Comments</td>
                        <td className="cell3 even">
                          {appointmentDetails?.reviewcomments!=undefined &&appointmentDetails?.reviewcomments!="NA" ?appointmentDetails?.reviewcomments : "NA"}
                        </td>
                      </tr> 
                  }
                <tr>
                  <td className="cell1 odd">Status</td>

                  <td className="cell3 odd">
                    {appointmentDetails?.consultationstatus}
                  </td>
                </tr>
                {appointmentDetails?.Comments != undefined &&
                  appointmentDetails?.Comments != "" && (
                    <tr>
                      <td className="cell1 odd">Reason for Booking</td>

                      <td className="cell3 odd">
                        {appointmentDetails?.Comments}
                      </td>
                    </tr>
                  )}
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Patient Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Name</td>
                  <td className="cell3 even">
                    {appointmentDetails?.patientname}
                  </td>
                </tr>

                {/* <tr>
                  <td className="cell1 odd">New/Existing</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.NewOrExisting}
                  </td>
                </tr> */}

                <tr>
                  <td className="cell1 even">Visit Count</td>
                  <td className="cell3 even">
                    {appointmentDetails?.Visit_Count}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">MRN Number</td>
                  <td className="cell3 odd">{appointmentDetails?.MRNnumber}</td>
                </tr>

                <tr>
                  <td className="cell1 even">Location</td>
                  <td className="cell3 even">{appointmentDetails?.Location}</td>
                </tr>

                <tr>
                  <td className="cell1 odd">Email ID</td>
                  <td className="cell3 odd">
                    {appointmentDetailsV2?.PatientEmail}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Phone Number</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.PatientMobile}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Gender</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientGender || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Date Of Birth</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientDob ? (
                      <>
                        {(() => {
                          const dob = appointmentDetailsV2.patientDob;
                          const dobDate = new Date(dob);
                          const currentDate = new Date();
                          const ageInMonths = Math.floor(
                            (currentDate - dobDate) /
                              (1000 * 60 * 60 * 24 * 30.4375)
                          ); // Average number of days in a month
                          const ageInYears = Math.floor(ageInMonths / 12);

                          const formattedDob = new Intl.DateTimeFormat(
                            "en-GB",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )
                            .format(dobDate)
                            .replace(/ /g, "/");

                          if (ageInMonths < 1) {
                            return `${formattedDob}, 1 month`;
                          } else if (ageInMonths < 12) {
                            return `${formattedDob}, ${ageInMonths} months`;
                          } else {
                            return `${formattedDob}, ${ageInYears} years`;
                          }
                        })()}
                      </>
                    ) : (
                      ""
                    )}
                    {console.log("Dob", appointmentDetailsV2?.patientDob)}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Address</td>
                  <td className="cell3 even">
                    {appointmentDetailsV2?.patientaddress || "NA"}
                  </td>
                </tr>
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Doctor Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Doctor ID</td>
                  <td className="cell3 odd">{appointmentDetails?.doctor_id}</td>
                </tr>

                <tr>
                  <td className="cell1 even">Name</td>
                  <td className="cell3 even">
                    {appointmentDetails?.doctor_name}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Specialty</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.doctor_speciality}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Hospital Name</td>
                  <td className="cell3 even">
                    {appointmentDetails?.hospital_name}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Fees Calculation
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Status</td>
                  <td className="cell3 odd">
                  {appointmentDetails?.Fees_status !== "N/A" ? appointmentDetails?.Fees_status : "NA"}                  
                  </td>
                 
                </tr>

                <tr>
                  <td className="cell1 even">Payment ID</td>
                  <td className="cell3 even">
                    {appointmentDetails?.payment_id || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Refund ID</td>
                  <td className="cell3 odd">{appointmentDetails?.refund_id || "NA"}</td>
                </tr>

                <tr>
                  <td className="cell1 even">Received from Patient</td>
                  <td className="cell3 even">
                    {appointmentDetails?.patient_fee_received || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Payment Mode</td>
                  <td className="cell3 odd">
                  {appointmentDetails?.payment_mode !== "N/A" ? appointmentDetails?.payment_mode : "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Payment Date & Time</td>
                  <td className="cell3 even">
                    {appointmentDetails?.payment_id === "NA" &&
                    appointmentDetails?.bookedBy === "admin"
                      ? "NA"
                      : appointmentDetails?.paymentdatetime || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Payment Channel</td>
                  <td className="cell3 even">
                    {appointmentDetails?.Payment_Channel || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Invoice file</td>
                  <td className="cell3 odd">
                    <span
                      className="file_open_link"
                      onClick={() => {
                        openFile();
                      }}
                    >
                      {" "}
                      {appointmentDetails?.Invoice_File}
                    </span>
                  </td>
                </tr>

                {/* <tr>
                  <td className="cell1 even">Doctor Fees</td>
                  <td className="cell3 even">
                    {appointmentDetails?.doctor_fees}
                  </td>
                </tr> */}

                {/* <tr>
                            <td className='cell1 odd'>Discounts</td>
                            <td className='cell3 odd'>{appointmentDetails?.Discounts}</td>
                        </tr>

                        <tr>
                            <td className='cell1 even'>C2MD Fees</td>
                            <td className='cell3 even'>{appointmentDetails?.c2md_fees}</td>
                        </tr>

                        <tr>
                            <td className='cell1 odd'>GST on C2MD Fees</td>
                            <td className='cell3 odd'>{appointmentDetails?.GST_on_C2MD_Fees}</td>
                        </tr> */}

                {/* <tr>
                  <td className="cell1 even">PG Fees</td>
                  <td className="cell3 even">{appointmentDetails?.PG_Fees}</td>
                </tr>

                <tr>
                  <td className="cell1 odd">Refund Amount</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.Refund_Amount}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">PG Refund Fees</td>
                  <td className="cell3 even">
                    {appointmentDetails?.PG_Refund_Fees}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">GST on Refund Fees</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.PG_Refund_GST}
                  </td>
                </tr> */}
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={2}>
                    Pay Out
                  </td>
                </tr>

                {/* <tr>
                           
                            <td className='cell1 even'>Gross Amount</td>
                            <td className='cell3 even'>{appointmentDetails?.Gross_Amount}</td>
                        </tr>

                        <tr>
                            <td className='cell1 odd'>Tax</td>
                            <td className='cell3 odd'>{appointmentDetails?.TAX}</td>
                        </tr> */}

                <tr>
                  <td className="cell1 even">Net Amount Payable</td>
                  <td className="cell3 even">
                    {appointmentDetails?.patient_fee_received}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="loader" style={{ width: "100%", textAlign: "center" }}>
          <Skeleton active />
        </div>
      )}
    </div>
  );
}

export default MisReportModalContent;
